export default __webpack_public_path__ + "static/media/bridge.c2f21567.jpg";